<template>
<div class="ti">
  <div style="margin-left: 20px; margin-top: 20px; margin-bottom: 20px">
    <el-row v-loading="loading">
      <el-col :span="4">
        <span class="total">房产数：{{dataList.houseNUm}}</span>
      </el-col>
      <el-col :span="4">
        <span class="total">放租意向：{{dataList.status0Num}}</span>
      </el-col>
      <el-col :span="4">
        <span class="total">租赁中：{{dataList.status1Num}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        分类：
        <el-select v-model="search.type_id" filterable placeholder="选择分类" clearable size="mini">
          <el-option
            v-for="(item,index) in search.type_list"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        战区：
        <el-select v-model="search.region" placeholder="请选择战区" filterable clearable size="mini">
          <template v-for="item in search.region_list">
            <el-option :label="item.name" :value="item.id"/>
            <template v-for="sub in item.children">
              <el-option :label="'  - ' + sub.name" :value="sub.id" />
            </template>
          </template>
        </el-select>
      </el-col>
      <el-col :span="4">
        项目：
        <el-select v-model="search.project" placeholder="请选择项目"  filterable clearable size="mini">
          <template v-for="(item,index) in search.project_list">
            <el-option :label="item.house_name" :value="item.erp_pindex_id"></el-option>
          </template>
        </el-select>
      </el-col>
      <el-col :span="4">
        区域：
        <el-select v-model="search.area" placeholder="请选择区域" filterable clearable size="mini">
          <template v-for="(item,index) in search.area_list">
            <el-option :label="item.house_name" :value="item.house_id"></el-option>
          </template>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button size="mini" style="color: #FFFFFF" type="primary" @click="searchData">搜索</el-button>
      </el-col>
    </el-row>

  </div>
  <v-divider></v-divider>
  <el-tabs v-model="activeName" style="margin-left: 20px">
    <el-tab-pane label="租赁中" name="first">
      <div class="table-wrap">
        <el-table
          v-loading="loadingA"
          v-if="dataListA" :data="dataListA.list"
          border
          style="width: 100%">
          <el-table-column
            prop="address"
            label="房产" width="320">
            <template slot-scope="scope">
              {{scope.row.address}}
            </template>
          </el-table-column>
          <el-table-column
            prop="is_ceased"
            label="出租状态"
            width="100">
            <template slot-scope="scope">
              {{scope.row.is_ceased?'当前':'无'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="rent_customer_name"
            label="承租人"
            width="150">
            <template slot-scope="scope">
              {{scope.row.rent_customer_name}}
            </template>
          </el-table-column>
          <el-table-column
            prop="customer_name"
            label="业主名称"
            width="150">
            <template slot-scope="scope">
              {{scope.row.customer_name}}
            </template>
          </el-table-column>
          <el-table-column
            prop="contract_id"
            label="合同编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="begin_date"
            label="承租日期"
            width="150">
          </el-table-column>
          <el-table-column
            prop="cease_date"
            label="退租日期"
            width="150">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="dataListA.total*1"
                       :page-size="dataListA.pageSize*1" :current-page="dataListA.page*1"
                       @current-change="pageChangeA"></el-pagination>
      </div>
    </el-tab-pane>
    <el-tab-pane label="放租意向" name="second">
      <div class="table-wrap">
          <el-table
            v-loading="loadingB"
            v-if="dataListB" :data="dataListB.list"
            border
            style="width: 100%">
            <el-table-column
                prop="address"
                label="房产" width="320">
                <template slot-scope="scope">
                  {{scope.row.address}}
                </template>
              </el-table-column>
              <el-table-column
                prop="is_ceased"
                label="状态"
                width="100">
                <template slot-scope="scope">
                  出租中
                </template>
              </el-table-column>
              <el-table-column
                prop="contract_id"
                label="合同编号"
                width="100">
              </el-table-column>
              <el-table-column
                prop="phone"
                label="联系方式"
                width="100">
              </el-table-column>
              <el-table-column
                prop="extent"
                label="面积"
                width="100">
              </el-table-column>
              <el-table-column
                prop="furniture"
                label="家私配备"
                width="100">
              </el-table-column>
              <el-table-column
                prop="rent"
                label="意向租金"
                width="100">
              </el-table-column>
              <el-table-column
                prop="deposit"
                label="押金"
                width="100">
              </el-table-column>
              <el-table-column
                prop="management_expense"
                label="管理费"
                width="100">
              </el-table-column>
              <el-table-column
                prop="water_electricity"
                label="水电费"
                width="100">
              </el-table-column>
              <el-table-column
                prop="orther"
                label="其他要求"
                width="100">
              </el-table-column>
            </el-table>
        </div>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="dataListB.total*1"
                         :page-size="dataListB.pageSize*1" :current-page="dataListB.page*1"
                         @current-change="pageChangeB"></el-pagination>
        </div>
      </el-tab-pane>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import Http from "../../Oa/common/OaHttp";
import UserProjectInfo from "../../Butler/common/UserProjectInfo";

export default {
  name: 'CustomerRentMasterPreview',
  components: {},
  data () {
    return {
      isIndeterminate: false,
      status_total: [],
      loading: false,
      loadingA: false,
      loadingB: false,
      activeName: 'first',
      search: {
        dateArr: [],
        region:'',
        region_list: [],
        project:'',
        project_list:[],
        area:'',
        area_list:'',
        project_ids:'',
        type_id:0,
        type_list : []
      },
      dataList : {
        'houseNUm': 0,
        'status0Num': 0,
        'status1Num': 0
      },
      dataListA : {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      dataListB : {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      projectRegion:[],
      projectList:[],
      areaList:[],
      regionListKeyById: {},
    }
  },
  //界面没出来前加载
  created() {

  },

  mounted(){

  },
  activated(){
    let region =  this.$route.query.region_name;
    let project =  this.$route.query.project_name;
    let member_type =  this.$route.query.member_type;
    let start_date =  this.$route.query.start_date;
    let end_date =  this.$route.query.end_date;

    // this.getRegionList()
    this.search.type_id = 1
    let that = this
    UserProjectInfo.ready(function(){
      that.search.type_list=UserProjectInfo.getTypeList();
      that.search.region_list = UserProjectInfo.getRegionList({type_id:that.search.type_id});
    },1)

  },
  computed:{

  },
  watch: {
    'search.type_id':function(newValue) {
      this.search.region = ''
      this.search.project = ''
      this.search.area = ''
      if (newValue === "") {
        this.search.region_list = []
        this.search.project_list = []
        this.search.area_list = []
      } else {
        this.search.region_list = UserProjectInfo.getRegionList({type_id:newValue});
      }

      this.search.project_ids = UserProjectInfo.getProjectIds({region_id:0, type_id:newValue})
      this.getRepairList()

    },
    'search.region':function(newValue) {
      this.search.project = ''
      this.search.area = ''
      if (newValue === "") {
        this.search.project_list = []
        this.search.area_list = []
      } else {
        this.search.project_list=UserProjectInfo.getProjectList({region_id:this.search.region, type_id:this.search.type_id});
      }

      this.search.project_ids = UserProjectInfo.getProjectIds({region_id:this.search.region, type_id:this.search.type_id})
      this.getRepairList()
    },
    'search.project':function(newValue) {
      this.search.area = ''
      if (newValue === "") {
        this.search.area_list = []
        this.search.project_ids = UserProjectInfo.getProjectIds({region_id:this.search.region, type_id:this.search.type_id})
      } else {
        this.search.project_ids = newValue
        this.search.area_list = UserProjectInfo.getAreaList(newValue);
      }
      this.getRepairList()
    },
    'search.area':function(newValue) {
      this.getRepairList()
    }
  },
  //事件
  methods: {
    searchData() {
      this.getRepairList()
    },
    getRepairList() {

      if (this.search.project_ids == '') {
        let projectIds = [];
        for (const k in this.search.region_list) {
          let item = this.search.region_list[k]
          let list = this.getProjectListByRegion(item.id)
          projectIds.push(list.map(item => item.erp_pindex_id))
        }
        this.search.project_ids = projectIds.join(',');
      }
      this.loading = true
      this.$myhttp.post('admin/HouseRentIntention/rentPreview',this.search,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];

        if(resData.code == 200){
          this.loading = false
          this.dataList = resData.data
        }
      });
      this.pageChangeA(1)
      this.pageChangeB(1)
    },
    handleClick(tab, event) {

    },
    pageChangeA(i) {
      this.dataListA.page = i
      this.getListA()
    },
    pageChangeB(i) {
      this.dataListB.page = i
      this.getListB()
    },
    getListA() {
      if (this.search.project_ids == '') {
        let projectIds = [];
        for (const k in this.search.region_list) {
          let item = this.search.region_list[k]
          let list = this.getProjectListByRegion(item.id)
          projectIds.push(list.map(item => item.erp_pindex_id))
        }
        this.search.project_ids = projectIds.join(',');
      }
      this.search.page = this.dataListA.page;
      this.search.page_size = this.dataListA.pageSize;
      this.loadingA = true
      this.$myhttp.post('admin/HouseRentIntention/rent',this.search,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loadingA = false
        let resData = backdata['data'];

        if(resData.code == 1){
          this.dataListA = resData.data
        }
      });
    },
    getListB() {
      if (this.search.project_ids == '') {
        let projectIds = [];
        for (const k in this.search.region_list) {
          let item = this.search.region_list[k]
          let list = this.getProjectListByRegion(item.id)
          projectIds.push(list.map(item => item.erp_pindex_id))
        }
        this.search.project_ids = projectIds.join(',');
      }
      this.search.page = this.dataListB.page;
      this.search.page_size = this.dataListB.pageSize;
      this.loadingB = true
      this.$myhttp.post('admin/HouseRentIntention/rentIntention',this.search,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loadingB = false
        let resData = backdata['data'];

        if(resData.code == 1){
          this.dataListB = resData.data
        }
      });
    },
    getRegionList() {
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/User/getUserProjectInfo", {'status':0}, res => {
        if (res.code == 0) {
          that.projectRegion = this.getRegionTree(0, res.data.region_list)
          that.projectList = res.data.project_list
          that.areaList = res.data.area_list

          for (const k in res.data.region_list) {
            this.regionListKeyById[res.data.region_list[k]['id']] = res.data.region_list[k];
          }

          that.search.region_list = this.getRegionTree(0, res.data.region_list)
          this.getRepairList()
        }
      });
    },
    // 战区列表转为树结构
    getRegionTree(id, d) {
      let list = []
      for(const k in d) {
        if(d[k].pid == id) {
          let item = d[k]
          item.children = this.getRegionTree(item.id, d)
          list.push(item)
        }
      }
      return list
    },
    selectRegion() {
      this.search.project = '';
      this.search.area = '';
      this.search.project_list = this.getProjectListByRegion(this.search.region);
      this.search.project_ids = this.getProjectIds(this.search);
      this.searchData()
    },
    selectProject() {
      this.search.area = '';
      this.search.area_list = this.getAreaList(this.search.project);
      this.searchData()
    },
    // 获取战区项目列表
    getProjectListByRegion(projectRegionId) {
      if (projectRegionId) {
        const regionItem = this.getRegion(projectRegionId)
        return this.projectList.filter(item => regionItem.pindex_id.includes(item.erp_pindex_id + ''))
      } else {
        return this.projectList
      }
    },

    // 获取项目的区域
    getAreaList(projectId) {
      if (projectId) {
        const projectItem = this.getProject(projectId)
        return this.areaList.filter(item => item.erp_pindex_id == projectItem.erp_pindex_id)
      } else {
        return []
      }
    },

    getRegion(id) {
      // let projectRegion = this.projectRegion
      // for (const k in projectRegion) {
      //   if (projectRegion[k].id == id) {
      //     return projectRegion[k]
      //   }
      // }
      return this.regionListKeyById[id];
    },

    getProject(id) {
      let projectList = this.projectList
      for (const k in projectList) {
        if (projectList[k].erp_pindex_id == id) {
          return projectList[k]
        }
      }
    },
    getProjectIds(data){
      let project_id = '';
      if(data.project) {
        project_id = data.project
      } else {
        if(data.region) {
          const list = this.getProjectListByRegion(data.region)
          project_id = list.map(item => item.erp_pindex_id).join(',')
        } else {
          project_id = this.projectList.map(item => item.erp_pindex_id).join(',')
        }
      }
      return project_id;
    }
  },

}
</script>
<style scoped>
.el-row {
  margin-bottom: 10px;
}
.ti{
  margin: 1%;
  width: 98%;
}
.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
}
.total {
      background-color: #ef6666;
      border-radius: 5px;
      padding: 6px;
      font-size: 17px;
      color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerRentMasterPreview.vue